<template>
  <div class="home">
    <div class="header fn-15">
      <p></p>
      {{ SyboList.syboml }}
      <svg
        @click="goLink('/ExchangeKline')"
        t="1712807357779"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="2337"
        width="200"
        height="200"
      >
        <path
          d="M232.727273 535.272727a69.818182 69.818182 0 0 1 69.818182 69.818182v186.181818a69.818182 69.818182 0 0 1-139.636364 0v-186.181818a69.818182 69.818182 0 0 1 69.818182-69.818182zM791.272727 162.909091a69.818182 69.818182 0 0 1 69.818182 69.818182v558.545454a69.818182 69.818182 0 0 1-139.636364 0V232.727273a69.818182 69.818182 0 0 1 69.818182-69.818182z m-279.272727 139.636364a69.818182 69.818182 0 0 1 69.818182 69.818181v418.909091a69.818182 69.818182 0 0 1-139.636364 0V372.363636a69.818182 69.818182 0 0 1 69.818182-69.818181z"
          fill="#ffffff"
          p-id="2338"
        ></path>
      </svg>
    </div>
    <div class="coin-exchange-box">
      <!-- 买入卖出 -->
      <div class="exchange-transaction">
        <!-- 买入卖出标题切换 -->
        <div class="traderTit">
          <div @click="buying(1)" class="titleBox">
            <img v-if="IMgShows" :src="buyImg" mode="widthFix" />
            <span>买入</span>
          </div>
          <div @click="buying(2)" class="titleBox">
            <img v-if="IMgShow" :src="sellImg" mode="widthFix" />
            <span class="txt">卖出</span>
          </div>
        </div>
        <div style="margin: 10px 0">
          <el-input
            v-model="from.limitPrice"
            placeholder="请输入价格"
            oninput="value=value.replace(/[^0-9.]/g,'')"
          ></el-input>
          <p>
            <!-- ≈2.888 CNY -->
          </p>
        </div>
        <div>
          <el-input
            v-if="sliderSellLimitPercent == 0"
            v-model="from.limitValue"
            placeholder="请输入数量"
            oninput="value=value.replace(/[^0-9.]/g,'')"
          ></el-input>
          <el-input
            v-else
            :value="from.limitValue"
            oninput="value=value.replace(/[^0-9.]/g,'')"
            @focus="onCloseAmountFocus"
          ></el-input>
          <div class="d-flex justify-between">
            <P>可用</P>
            <p>
              {{ usableBalance }}
              <span v-if="IMgShows == true">
                {{ SyboList.syboml.split("/")[1] }}</span
              >
              <span v-else> {{ SyboList.syboml.split("/")[0] }}</span>
            </p>
          </div>
        </div>
        <ul class="progressBox">
          <el-slider
            :min="0"
            :max="100"
            v-if="IMgShows"
            v-model="sliderSellLimitPercent"
            @input="changeBUY"
          ></el-slider>
          <!-- 买入选择百分比 -->
          <!-- <li v-if="IMgShows" v-for="item in sliderStep" :key="item"
                        :class="{ activeLired: sliderSellLimitPercent == item }" @click="Sclick(item)">
                        {{ item }}%
                    </li> -->
          <!-- 卖出选择百分比 -->
          <!-- <li v-if="IMgShow" v-for="item in sliderStep" :key="item"
                        :class="{ activeLis: sliderSellLimitPercent == item }" @click="Sclick(item)">
                        {{ item }}%
                    </li> -->
          <el-slider
            :min="0"
            :max="100"
            v-if="IMgShow"
            v-model="sliderSellLimitPercent"
            @input="changeBUY"
          ></el-slider>
        </ul>
        <div v-show="isLogin">
          <div
            :loading="IsAdd"
            v-if="IMgShows == true"
            class="btnBox green"
            @click="buyWithLimitPrice(0)"
          >
            <span>买入</span>
            {{ SyboList.syboml.split("/")[0] }}
          </div>
          <!-- IsAdd -->
          <div
            :loading="IsAdd"
            v-else
            class="btnBox red"
            @click="buyWithLimitPrice(1)"
          >
            <span>卖出</span>
            {{ SyboList.syboml.split("/")[0] }}
          </div>
        </div>

        <div
          class="btnBox"
          v-show="!isLogin"
          :class="IMgShows == true ? 'green' : 'red'"
        >
          <router-link to="/">
            <span style="color: #fff">登录</span>
          </router-link>
        </div>
      </div>
      <!-- 买卖盘 -->
      <div class="sellBuyBox">
        <div class="d-flex justify-between align-center">
          <div>
            价格
            <p style="font-size: 12px">({{ SyboList.base }})</p>
          </div>

          <div>
            数量
            <p style="font-size: 12px">
              ( {{ SyboList.syboml.split("/")[0] }})
            </p>
          </div>
        </div>
        <!-- 卖盘 -->
        <div
          class="boxs d-flex justify-between align-center"
          v-for="(item, index) in plate.askRows"
          :key="index + 'a'"
          @click="buyPlate(item)"
        >
          <div class="color-sell" v-if="Number(item.price) > 1">
            {{ Number(item.price).toFixed(3) }}
          </div>
          <div class="color-sell" v-if="Number(item.price) < 1">
            {{ Number(item.price).toFixed(3) }}
          </div>
          <div v-if="Number(item.price) > 1">
            {{ Number(item.quantity).toFixed(baseCoinScale) }}
          </div>
          <div v-if="Number(item.price) < 1">
            {{ Number(item.quantity).toFixed(2) }}
          </div>
          <div
            class="bg"
            :style="{ width: getValue(item.quantity) + '%' }"
          ></div>
        </div>
        <!-- 最新价 -->
        <div class="priceNumBox">
          <span
            class="fn-18 fn-bold"
            :class="marketList.raf * 1 > 0 ? 'color-buy' : 'color-sell'"
            >{{ Number(marketList.last).toFixed(baseCoinScale) }}</span
          >
          <span v-if="marketList.raf > 0" class="color-buy"> ↑ </span>
          <span v-else-if="marketList.raf < 0" class="color-sell"> ↓ </span>
          <!-- <p class="fn-16  color-light">
                        {{ $store.state.RateName }}{{ (Number($store.state.RateMoney) *
                            Number(marketList.last)).toFixed(baseCoinScale) }}
                    </p> -->
        </div>
        <!-- 买盘 -->
        <div
          class="boxs d-flex justify-between align-center"
          v-for="(item, index) in plate.bidRows"
          :key="index + 'b'"
          @click="sellPlate(item)"
        >
          <div class="color-buy" v-if="Number(item.price) > 1">
            {{ Number(item.price).toFixed(3) }}
          </div>
          <div class="color-buy" v-if="Number(item.price) < 1">
            {{ Number(item.price).toFixed(3) }}
          </div>
          <div v-if="Number(item.price) > 1">
            {{ Number(item.quantity).toFixed(baseCoinScale) }}
          </div>
          <div v-if="Number(item.price) < 1">
            {{ Number(item.quantity).toFixed(2) }}
          </div>
          <div
            class="bg bg2"
            :style="{ width: getValue(item.quantity) + '%' }"
          ></div>
        </div>
      </div>
    </div>
    <!-- 当前委托/历史委托 -->
    <div class="d-flex Entrust">
      <ul v-for="(item, index) in NameList" :key="index">
        <li
          @click="ACtive = 0"
          v-if="index == 0"
          :class="ACtive == index ? 'ColorW' : 'ColorHs'"
        >
          {{ item.txt }} ({{ CommissionRecord.length }})
        </li>
        <li
          v-else
          @click="ACtive = 1"
          :class="ACtive == index ? 'ColorW' : 'ColorHs'"
        >
          {{ item.txt }}
        </li>
      </ul>
    </div>
    <div class="Record">
      <ul v-if="ACtive == 1">
        <van-list
          v-model:loading="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="到底啦~"
          @load="onLoad"
        >
          <li v-for="(item, index) in CommissionHistory" :key="index">
            <div class="d-flex justify-between">
              <div class="d-flex justify-between btnGr">
                <div :class="item.direction == 0 ? 'greend' : 'red'">
                  <span>
                    {{ item.direction == 0 ? "买入" : "卖出" }}
                  </span>
                </div>
                <div>{{ item.symbol }}</div>
              </div>
              <div
                :style="item.direction == 0 ? 'color:#00CF8B' : 'color:red;'"
                style="padding: 15px 15px"
                v-if="ACtive == 1"
              >
                {{
                  item.status == 3
                    ? "已撤单"
                    : item.status == 2
                    ? "已成交"
                    : "待成交"
                }}
              </div>
            </div>
            <div>
              <div class="Record_listOne">
                <div class="d-flex justify-between">
                  <div class="d-flex">
                    <p>{{ Number(item.amount).toFixed(3) }}</p>
                    <p>{{ Number(item.entrustPrice).toFixed(3) }}</p>
                  </div>
                  <div>
                    <p>{{ item.createTime | dateFormat }}</p>
                  </div>
                </div>
              </div>
              <div class="Record_listOne" style="margin-top: 5px">
                <div class="d-flex justify-between">
                  <div class="d-flex">
                    <p>{{ item.direction == 0 ? "委托金额" : "委托数量" }}</p>

                    <p>委托单价</p>
                  </div>
                  <div>
                    <p>委托时间</p>
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-top: 20px">
              <div class="Record_listOne">
                <div class="d-flex justify-between">
                  <div class="d-flex">
                    <p>{{ Number(item.turnover).toFixed(3) }}</p>
                    <p>{{ Number(item.tradedPrice).toFixed(3) }}</p>
                  </div>
                  <div>
                    <p>{{ item.tradedAmount }}</p>
                  </div>
                </div>
              </div>
              <div
                class="Record_listOne"
                style="margin: 5px 0; padding-bottom: 10px"
              >
                <div class="d-flex justify-between">
                  <div class="d-flex">
                    <p>成交总额</p>
                    <p>成交均价</p>
                  </div>
                  <div>
                    <p>成交量</p>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </van-list>
      </ul>
      <ul v-else>
        <li v-for="(item, index) in CommissionRecord" :key="index">
          <div class="d-flex justify-between">
            <div class="d-flex justify-between btnGr">
              <div :class="item.direction == 0 ? 'greend' : 'red'">
                <span>
                  {{ item.direction == 0 ? "买入" : "卖出" }}
                </span>
              </div>
              <div>{{ item.symbol }}</div>
            </div>
            <div
              @click="Drawal(item.orderId)"
              style="padding: 15px 15px; color: #1484c4"
              v-if="ACtive == 0"
            >
              撤销
            </div>
          </div>
          <div>
            <div class="Record_listOne">
              <div class="d-flex justify-between">
                <div class="d-flex">
                  <p>{{ Number(item.amount).toFixed(3) }}</p>
                  <p>{{ Number(item.entrustPrice).toFixed(3) }}</p>
                </div>
                <div>
                  <p>{{ item.createTime | dateFormat }}</p>
                </div>
              </div>
            </div>
            <div class="Record_listOne" style="margin-top: 5px">
              <div class="d-flex justify-between">
                <div class="d-flex">
                  <p>委托数量</p>
                  <p>委托单价</p>
                </div>
                <div>
                  <p>委托时间</p>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-top: 20px">
            <div class="Record_listOne">
              <div class="d-flex justify-between">
                <div class="d-flex">
                  <p>{{ Number(item.turnover).toFixed(3) }}</p>
                  <p>{{ Number(item.tradedPrice).toFixed(3) }}</p>
                </div>
                <div>
                  <p>{{ item.tradedAmount }}</p>
                </div>
              </div>
            </div>
            <div
              class="Record_listOne"
              style="margin: 5px 0; padding-bottom: 10px"
            >
              <div class="d-flex justify-between">
                <div class="d-flex">
                  <p>成交总额</p>
                  <p>成交均价</p>
                </div>
                <div>
                  <p>成交量</p>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="system_dialog">
      <el-dialog title="提示" :visible.sync="dialogVisible" width="90%">
        <span>此操作将撤销当前这个订单，是否继续？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="qd">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <Tabbar :active="2"></Tabbar>
  </div>
</template>
<script>
import Vue from "vue";
import { NoticeBar } from "vant";
Vue.use(NoticeBar);
import math from "@/assets/js/math";
// var wsPath = "ws://192.168.2.106:8024/exchange/websocket/All/"; //测试
var wsPath = "wss://tianyis.me/api/websocket/All/"; //正式
var Stomp = require("stompjs");
var SockJS = require("sockjs-client");
import { mainApiData } from "@/request/api.js";
export default {
  data() {
    return {
      baseApi: "",
      SyboList: {
        coin: "FIL",
        base: "USDT",
        price: 4.3972,
        rate: 29.12,
        ref: 29.21,
        syboml: "FIL/USDT",
      },
      buyImg: require("../../assets/img/exchange/mairu-xuanzhong.png"), //左侧图标
      sellImg: require("../../assets/img/exchange/maichu.png"), //右侧图标
      IMgShow: false,
      IMgShows: true,
      direction: "BUY", // buy买入 1卖出
      from: {
        limitPrice: "",
        limitValue: "",
      },
      sliderStep: [25, 50, 75, 100],
      sliderSellLimitPercent: 0,
      plate: {
        maxPostion: 7,
        bidRows: [],
        askRows: [],
      },
      marketList: {},
      baseCoinScale: 4,
      NameList: [
        {
          txt: "当前委托",
        },
        {
          txt: "历史委托",
        },
      ],
      ACtive: 0,
      CommissionRecord: [], //当前委托
      CommissionHistory: [], //历史委托
      socketLst: "", //心跳
      dialogVisible: false,
      orderId: 0,
      loading: false,
      finished: false,
      pageNo: 0,
      pageSize: 10,
      usableBalance: 0,
      IsAdd: false,
      stompClient: null,
    };
  },
  computed: {
    isLogin() {
      return this.$store.getters.isLogin;
    },
    member: function () {
      return this.$store.getters.member;
    },
  },
  created() {
    this.baseApi = process.env.VUE_APP_IMG;
    this.init();
  },
  beforeDestroy() {
    if (this.stompClient && this.stompClient.connected) {
      this.stompClient.disconnect();
      this.stompClient = null;
    }
  },
  watch: {
    ACtive: function (val) {
      if (val == 1) {
        this.pageNo = 0;
        this.pageSize = 10;
        this.CommissionHistory = [];
        this.onLoad();
      } else {
        this.pageNo = 0;
        this.pageSize = 10;
        this.CommissionHistory = [];
      }

      // console.log(val,'val');
    },
  },
  methods: {
    goLink(val) {
      this.$router.push({
        path: val,
      });
    },
    Sclick(item) {
      console.log("item :>> ", item);
      this.sliderSellLimitPercent = item;
      this.from.limitValue = this.usableBalance * (item / 100);
    },
    changeBUY(val) {
      this.sliderSellLimitPercent = val;
      this.from.limitValue = this.usableBalance * (val / 100);
    },
    onCloseAmountFocus() {
      this.sliderSellLimitPercent = 0;
    },
    onLoad() {
      this.pageNo++;
      let parme = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        symbol: this.SyboList.syboml,
      };
      mainApiData.ExchangeHistory(parme).then((res) => {
        if (res.data.code == 200) {
          for (let i = 0; i < res.data.data.records.length; i++) {
            this.CommissionHistory.push(res.data.data.records[i]);
          }
          this.total = res.data.total;
        }
      });
      this.loading = false;
      if (this.CommissionHistory.length >= this.total) {
        this.finished = true;
      }
    },
    //撤销
    Drawal(id) {
      this.dialogVisible = true;
      this.orderId = id;
    },
    getAssets() {
      if (this.IMgShows) {
        mainApiData
          .getAssetsByCoinName({
            coinName: this.SyboList.syboml.split("/")[1],
          })
          .then((res) => {
            this.usableBalance = res.data.data.usableBalance;
          });
      } else {
        mainApiData
          .getAssetsByCoinName({
            coinName: this.SyboList.syboml.split("/")[0],
          })
          .then((res) => {
            this.usableBalance = res.data.data.usableBalance;
          });
      }

      this.pageNo = 0;
      this.CommissionHistory = [];
      this.from.limitValue = "";
      this.onCloseAmountFocus();
      this.onLoad();
    },
    qd() {
      mainApiData
        .Withdrawal({
          orderId: this.orderId,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$toast("撤单成功");
            this.getAssets();
            this.dialogVisible = false;
          } else {
            this.getAssets();
            this.$toast(res.data.msg);
            this.dialogVisible = false;
          }
        });
    },

    buyPlate(item) {
      this.from.limitPrice = item.price;
    },
    sellPlate(item) {
      this.from.limitPrice = item.price;
    },
    initWebSocket() {
      if (typeof WebSocket == "undefined") {
        console.log("您的浏览器不支持WebSocket");
      } else {
        console.log("您的浏览器支持WebSocket");
        let id = 0;
        if (this.member == null) {
          id = Date.now();
        } else {
          id = this.member.userId;
        }
        // console.log("您的浏览器支持WebSocket");
        //实现化WebSocket对象，指定要连接的服务器地址与端口  建立连接
        var wsPathStr = wsPath + id;
        var socket = new WebSocket(wsPathStr);
        this.socketLst = socket;
        let that = this;
        //打开事件
        socket.onopen = function () {
          that.Toime(socket);
          setInterval(() => {
            that.Toime(socket);
          }, 50000);
        };
        //关闭事件
        socket.onclose = function () {
          console.log("Socket已关闭");
          window.location.reload();
          // this.initWebSocket();
        };
        //发生了错误事件
        socket.onerror = function () {
          window.location.reload();
          // this.initWebSocket();
          //此时可以尝试刷新页面
        };
      }
    },
    Toime(socket) {
      let id = 0;
      if (this.member == null) {
        id = Date.now();
      } else {
        id = this.member.userId;
      }
      let arr = JSON.stringify({
        ping: "ping",
        id: id,
        symbol: this.SyboList.syboml,
      });
      socket.send(arr);
    },
    // 开启ws
    startWebsock() {
      var that = this;
      var socket = new SockJS("https://tianyis.me/api/market-ws");
      that.stompClient = Stomp.over(socket);
      that.stompClient.debug = false;
   
      that.stompClient.connect(
        {},
        (frame) => {
          that.onConnected(that,that.stompClient);
        },
        that.onError
      );
      // if (this.stompClient) {
      //   this.stompClient.ws.close();
      //   return;
      // }
      // var stompClient = null;
      // var that = this;
      // var socket = new SockJS("https://tianyis.me/api/market-ws");
      // stompClient = Stomp.over(socket);
      // this.stompClient = stompClient;
      // stompClient.debug = false;
      // stompClient.connect(
      //   {},
      //   function (frame) {
      //     // 连接成功
      //     that.successCallback(that, stompClient);
      //     // that.connectes();
      //   },
      //   (error) => {
      //     // 断开重连使用定时器定时连接服务器
      //     that.reconnect(that);
      //   }
      // );
    },
    onConnected(that,stompClient) {
      let id = that.member ? that.member.userId : Date.now();
      that.initWebSocket();
      //订阅价格变化消息 行情
      stompClient.subscribe("/topic/cheng/tickers/" + id, function (msg) {
        var resp = JSON.parse(msg.body);

        that.marketList = resp || [];
      });
      //订阅盘口
      stompClient.subscribe("/topic/cheng/plate/" + id, function (msg) {
        var resp = JSON.parse(msg.body);
        that.plate.askRows = resp.asks|| [];
        that.plate.bidRows = resp.bids|| [];
      });

      // 推送用户委托
      stompClient.subscribe("/topic/cheng/order/" + id, function (msg) {
        var resp = JSON.parse(msg.body);
        if (that.ACtive == 0) {
          that.CommissionRecord = resp|| [];
        }
      });

      // this.connectes();
    },
    onError(error) {
      console.log("连接失败", error);
      this.reconnect();
    },
    // 断开重连使用定时器定时连接服务器
    reconnect() {
      setTimeout(() => {
        this.startWebsock();
      }, 2000);
    },

    // 获取深度
    getValue(amount) {
      //获取下面颜色
      const arr = this.plate.bidRows
        .concat(this.plate.askRows)
        .map((item) => item.quantity);
      let max = Math.max(...arr);
      return math.division(amount, max, 2) * 100;
    },
    buyWithLimitPrice(val) {
      this.IsAdd = true;
      if (this.from.limitValue == "") {
        this.$toast("数量不能为空");
        return;
      }
      if (this.from.limitPrice == "") {
        this.$toast("价格不能为空");
        return;
      }
      mainApiData
        .addOrder({
          amount: this.from.limitValue,
          entrustPrice: this.from.limitPrice,
          symbol: this.SyboList.syboml,
          direction: val,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.IsAdd = false;
            this.$toast("下单成功");
            this.getAssets();
          } else {
            this.IsAdd = false;
            this.$toast(res.data.msg);
            this.getAssets();
          }
        });
    },
    init() {
      if (localStorage.getItem("symbolEchange") != null) {
        this.SyboList.syboml = localStorage.getItem("symbolEchange");
      }
      this.getAssets();
      if (this.socketLst == "") {
        // alert(1)
        this.startWebsock();
      }
      let that = this;
      setTimeout(() => {
        that.from.limitPrice = that.marketList.last;
      }, 3000);
    },
    //买入buying
    buying(val) {
      if (val == 1) {
        // 切换图片 切换颜色
        this.direction = "BUY";
        this.IMgShows = true;
        this.IMgShow = false;
        mainApiData
          .getAssetsByCoinName({
            coinName: this.SyboList.syboml.split("/")[1],
          })
          .then((res) => {
            this.usableBalance = res.data.data.usableBalance;
          });
      } else {
        // 切换图片 切换颜色
        this.direction = "SELL";
        this.IMgShows = false;
        this.IMgShow = true;
        mainApiData
          .getAssetsByCoinName({
            coinName: this.SyboList.syboml.split("/")[0],
          })
          .then((res) => {
            this.usableBalance = res.data.data.usableBalance;
          });
      }
      this.changeActionTit();
    },
    // 切换限价市价
    changeActionTit(tab, event) {
      // console.log(tab, event);
      this.sliderBuyLimitPercent = 0;
      this.sliderSellLimitPercent = 0;
      this.sliderBuyMarketPercent = 0;
      this.sliderSellMarketPercent = 0;
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
// 引入全局的样式
@import "@/assets/scss/base.scss";

.home {
  .system_dialog {
    ::v-deep .el-dialog__wrapper {
      background: #090101;
      opacity: 0.8;
    }

    ::v-deep .el-dialog,
    ::v-deep .el-button {
      background: rgba(20, 132, 195, 0.2);

      color: #ffffff;
      /* 黄/主题 */

      border: 0.5px solid #1484c4;
      box-shadow: 0px 0px 6px 2px rgba(20, 132, 195, 0.25),
        inset 0px 0px 6px -2px rgba(20, 132, 195, 0.25);
      border-radius: 4px;
    }
    ::v-deep .el-dialog {
      background: url(../../assets/img/page/TC-345X233.png) no-repeat;
      background-size: 100% 100%;
    }
    ::v-deep .el-dialog__title,
    ::v-deep .el-dialog__body {
      color: #ffffff;
    }
  }

  .header {
    display: flex;
    justify-content: space-between;
    svg {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
    position: fixed;

    left: 0;
    right: 0;
    top: 0;
    padding: 10px 0;
    // border: 1px solid red;

    // background: #03080F;

    // margin: 10px 0;
    text-align: center;
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;

    color: #fefefe;

    /* Inside auto layout */

    flex: none;
    order: 1;
    flex-grow: 0;
    z-index: 999999;
  }

  .ColorHs {
    color: #999999;
  }

  .ColorW {
    color: #fff;
  }

  .coin-exchange-box {
    border-radius: 20px 20px 0px 0px;

    display: grid;
    grid-template-columns: 50% 47%;
    justify-content: space-between;
    padding: 20px 10px;
    margin-top: 50px;

    // 买入卖出
    .exchange-transaction {
      /deep/ .el-input-number__increase,
      /deep/ .el-input-number__decrease {
        background: transparent;
        border: 0;
        margin: 5px 0;
        color: #9fa6b5;
        // width:100%;
      }

      ::v-deep .el-input-number {
        width: 100%;
      }

      // input
      ::v-deep .el-input-group__append,
      ::v-deep .el-input-group__prepend,
      ::v-deep .el-input__inner,
      ::v-deep .el-input.is-disabled .el-input__inner {
        background: $panel-9;
        border: 1px solid var(--border-color);
        // border: none;
        text-align: center;
        color: #fff !important;
      }

      ::v-deep .el-input__inner {
        border-left: none;
        border-right: none;
        color: #fff !important;
      }

      ::v-deep .el-input {
        margin: 7px 0;
        font-size: 12px;
      }

      .traderTit {
        // height: 36px;
        display: flex;
        border-radius: 8px;
        background: $panel-9;
        border: 1px solid var(--border-color);
        justify-content: space-between;
        color: #fff;

        // border: 1px solid red;
        .titleBox {
          width: 48%;
          height: 35px;
          position: relative;

          img {
            width: 100%;
            // margin-left: 10px;
            height: 100%;
          }

          span {
            position: absolute;
            top: 13%;
            // margin-top: -5px;
            display: block;
            width: 100%;
            // height: 36px;
            // line-height: 33px;
            font-size: 16px;
            // color: #ffffff;
            text-align: center;
          }
        }
      }

      ::v-deep .el-input__inner {
        background: $panel-9;
        // background: transparent;
        border: 1px solid var(--border-color);
        padding: 0 10px;
        color: #fff !important;
      }

      .progressBox {
        // display: grid;
        // grid-template-columns: 24% 24% 24% 24%;
        // justify-content: space-between;
        margin: 25px 10px;

        li {
          background: $panel-2;
          text-align: center;
          border-radius: 2px;
          padding: 6px 0;
          cursor: pointer;
        }

        .activeLi {
          background: $panel-4;
          color: #fff;
        }

        .activeLis {
          background: #f6465d;
          color: #fff;
        }

        .activeLired {
          background: #00cf8b;
          color: #fff;
        }
      }

      .btnBox {
        border-radius: 3px;
        padding: 10px 0;
        margin-top: 15px;
        text-align: center;
      }
    }

    .sellBuyBox {
      .priceNumBox {
        // border: 1px solid red;
        text-align: center;
        padding: 10px 0;
        // font-size: 5px !important;
      }

      .boxs {
        font-size: 12px;
        position: relative;
        margin: 3px 0;
        padding: 2px 2px;

        .bg {
          position: absolute;
          right: 0;
          top: 0;
          background: rgba(248, 100, 63, 0.16);
          height: 100%;
          z-index: 0;
        }

        .bg2 {
          background: rgba(8, 200, 99, 0.16);
        }
      }
    }
  }

  .Market {
    ul {
      li {
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 10px 10px;
        background: rgba(0, 62, 98, 0.2);
        /* 黄/主题 */
        border: 0.5px solid #1484c4;
        box-shadow: 0px 0px 10px 4px rgba(0, 62, 98, 0.25),
          inset 0px 0px 10px -4px rgba(0, 62, 98, 0.25);
        border-radius: 4px;
        /* Inside auto layout */
        flex: none;
        order: 0;
        flex-grow: 0;
        margin: 20px;

        div {
          &:nth-child(3) {
            margin-top: 3px;
            // border: 1px solid red;
            padding: 10px 10px;
            color: #fff;
            border-radius: 4px;
          }
        }

        .greend {
          background: #00aa66;
        }

        .red {
          background: red;
        }
      }
    }
  }

  .Entrust {
    box-shadow: 0 0.5px 0 #999999;
    /*添加下划线*/
    color: #fff;
    padding: 8px 10px;

    ul {
      &:nth-child(2) {
        margin-left: 20px;
      }
    }
  }

  .Record {
    // border: 1px solid red;
    padding-bottom: 100px;
    height: 500px;
    overflow: hidden;

    overflow-y: scroll;
    margin: 10px;

    .greend {
      background: #00aa66;
    }

    .red {
      background: red;
    }

    ul {
      li {
        .btnGr {
          padding: 10px 15px;

          div {
            &:nth-child(1) {
              padding: 5px 10px;
              border-radius: 4px;
              color: #fff;
            }

            padding: 5px;
          }
        }

        // background: rgba(0, 62, 98, 0.2);
      

        border: 0.5px solid #f89b19;
        /* 主题 */
        // border: 0.5px solid #1484c4;
        box-shadow: 0px 0px 6px 2px rgba(0, 62, 98, 0.25),
          inset 0px 0px 6px -2px rgba(0, 62, 98, 0.25);
        border-radius: 4px;
        margin: 20px 0;

        .Record_listOne {
          // border:1px solid red;
          padding: 5px 15px;

          div {
            width: 100%;
            color: #fff;

            div {
              &:nth-child(1) {
                p {
                  width: 100%;

                  &:nth-child(2) {
                    // border:1px solid red;
                    padding-left: 15px;
                  }
                }
              }
            }

            &:nth-child(2) {
              text-align: right;
            }
          }
        }
      }
    }
  }
}
</style>
